module.exports = __webpack_public_path__ + "static/media/anatomia.b01efec1.png";